'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { classNames } from '@/util/utils';
import FeatureBlock, { type FeatureInViewOptions } from './feature-block';
import type { ContentForFeatures } from '@/services/sanity/api/get-features-content';
const MOBILE_IN_VIEW_OPTIONS: FeatureInViewOptions = {
  margin: '-20% 0px -20% 0px',
  amount: 'some'
};
const DESKTOP_IN_VIEW_OPTIONS: FeatureInViewOptions = {
  amount: 0.5
};
interface FeatureScrollerProps {
  blocks: ContentForFeatures[];
}
export default function FeatureScroller(t0) {
  const $ = _c(25);
  const {
    blocks
  } = t0;
  const [activeSection, setActiveSection] = useState(0);
  const [inViewOptions, setInViewOptions] = useState(DESKTOP_IN_VIEW_OPTIONS);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const mq = window.matchMedia("(max-width: 767px)");
      const sync = () => {
        setInViewOptions(mq.matches ? MOBILE_IN_VIEW_OPTIONS : DESKTOP_IN_VIEW_OPTIONS);
      };
      sync();
      mq.addEventListener("change", sync);
      return () => mq.removeEventListener("change", sync);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = index => setActiveSection(index);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleInView = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = index_0 => {
      setActiveSection(index_0);
      document.getElementById(`feature-block-${index_0}`)?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const scrollToBlock = t4;
  const activeBlock = blocks[activeSection];
  const isActiveThemeDark = activeBlock?.theme === "dark";
  const activeDotClass = isActiveThemeDark ? "bg-white" : "bg-primary-9";
  const inactiveDotClass = isActiveThemeDark ? "bg-primary-6" : "bg-neutral-3";
  let t5;
  if ($[4] !== activeDotClass || $[5] !== activeSection || $[6] !== blocks || $[7] !== inactiveDotClass) {
    let t6;
    if ($[9] !== activeDotClass || $[10] !== activeSection || $[11] !== inactiveDotClass) {
      t6 = (block, index_1) => <button key={block.titleH1 ?? block.titleH2 ?? `section-${index_1}`} type="button" onClick={() => scrollToBlock(index_1)} className="w-4 h-4 rounded-full hover:opacity-90 transition-opacity flex items-center justify-center" aria-label={`Scroll to section ${index_1 + 1}`}><span className={classNames("w-2 h-4 rounded-lg", index_1 === activeSection ? activeDotClass : inactiveDotClass)} /></button>;
      $[9] = activeDotClass;
      $[10] = activeSection;
      $[11] = inactiveDotClass;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t5 = blocks.map(t6);
    $[4] = activeDotClass;
    $[5] = activeSection;
    $[6] = blocks;
    $[7] = inactiveDotClass;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <nav className="fixed right-5 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-4">{t5}</nav>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== blocks || $[16] !== inViewOptions) {
    let t8;
    if ($[18] !== inViewOptions) {
      t8 = (block_0, index_2) => <FeatureBlock key={block_0.titleH1 ?? block_0.titleH2 ?? index_2} id={index_2} content={block_0} inViewOptions={inViewOptions} onInView={handleInView} />;
      $[18] = inViewOptions;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    t7 = blocks.map(t8);
    $[15] = blocks;
    $[16] = inViewOptions;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <div className="relative w-screen">{t7}</div>;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}